import { render, staticRenderFns } from "./UserPointInvalidEditPopup.vue?vue&type=template&id=4a74720a&scoped=true"
import script from "./UserPointInvalidEditPopup.vue?vue&type=script&lang=js"
export * from "./UserPointInvalidEditPopup.vue?vue&type=script&lang=js"
import style0 from "./UserPointInvalidEditPopup.vue?vue&type=style&index=0&id=4a74720a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a74720a",
  null
  
)

export default component.exports